import { Box, Button, Chip, Divider, MenuItem, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ISettingSection from '../../../interfaces/ISettingSection.ts';
import IAdminSetting from '../../../interfaces/IAdminSetting.ts';
import { useTranslation } from 'react-i18next';
import Autocomplete from '@mui/material/Autocomplete';
import Upload from '../../common/Upload.tsx';

interface modelList {
	system_name: string;
	list: string[];
}

export default function SettingAdmin() {
	const { t } = useTranslation();
	const [loading, setLoaing] = useState(false);
	const [sections, setSections] = useState<ISettingSection[]>([]);
	const [settings, setSettings] = useState<IAdminSetting[]>([]);
	const [selectedSection, setSelectedSection] = useState<number>();
	const [models, setModels] = useState<string[]>([]);
	const [data, setData] = useState<any>({});
	const [file, setFile] = useState<any>([]);
	const [modelsList, setModelsList] = useState<modelList[]>([]);
	useEffect(() => {
		setLoaing(true);
		axios({
			url: `/admin/settings/${selectedSection ? selectedSection : ''}`,
		})
			.then(res => {
				if (res.data.success) {
					let response = res.data.data;
					setSettings(response.settings);
					fetchModelList(response.settings);
					setSections(response.sections);
					setSelectedSection(response.selectedSection.id);
				}
			})
			.finally(() => {
				setLoaing(false);
			});
		axios({
			url: `admin/settings/${models}`,
		}).then(res => {
			if (res.data.success) {
				setModels(res.data.data);
			}
		});
	}, [selectedSection, modelsList]);

	const fetchModelList = (list: IAdminSetting[]) => {
		if (selectedSection === 5) {
			list.forEach(item => {
				if ((modelsList.length === 0 || !modelsList.some(e => e.system_name === item.system_name)) && item.type === 'single_model') {
					axios({
						url: `admin/settings/model-data`,
						params: { model: item?.model },
					})
						.then(res => {
							if (res.data.success) {
								setModelsList(prevData => {
									const newItem = { system_name: item.system_name, list: res.data.data };
									const existingSystemNames = prevData.map(e => e.system_name);

									if (!existingSystemNames.includes(newItem.system_name)) {
										return [...prevData, newItem];
									}
									return prevData;
								});
							}
						})
						.catch(error => {
							console.error('Error fetching model data:', error);
						});
				}
			});
		}
	};

	const handleClickSection = (id: number) => () => {
		setSelectedSection(id);
		setData({});
	};
	const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		setData((prev: any) => ({
			...prev,
			[name]: value,
		}));
	};

	useEffect(() => {
		if (selectedSection === 7) {
			setData((prev: any) => ({
				...prev,
				campaign_create_video: file[0],
			}));
		}
	}, [file]);
	const handleChangeMultiSelectInput = (name: string) => (_: any, newValue: string[]) => {
		setData((prev: any) => {
			return {
				...prev,
				[name]: newValue,
			};
		});
	};

	const handleSubmit = () => {
		let formData = new FormData();
		Object.entries(data).forEach(([key, value]: any) => {
			formData.append(key, value);
		});
		formData.append('_method', 'put');
		axios({
			url: '/admin/settings',
			method: 'post',
			data: formData,
		})
			.then(response => {
				console.log('File uploaded successfully', response);
			})
			.catch(error => {
				console.error('Error uploading file', error);
			});
	};

	return (
		<Box className={'w-full rounded bg-white p-4 shadow-md'}>
			<div className={'mb-2 flex flex-row gap-2'}>
				{sections.map(section => (
					<Button onClick={handleClickSection(section.id)} disabled={loading} variant={section.id === selectedSection ? 'contained' : 'text'} key={section.id}>
						{t(section.title)}
					</Button>
				))}
			</div>
			<Divider />
			<div className={'mt-8 flex flex-col gap-3 px-4'}>
				{settings?.map(setting => (
					<div className={`flex flex-row items-center ${setting.type === 'separator' ? 'mx-auto my-4' : ''} gap-4`}>
						<Typography className={`basis-40`}>{t(setting.title)}</Typography>
						<div className={'flex grow basis-0 flex-col gap-1'}>
							{setting.type === 'number' ? <TextField size={'small'} placeholder={setting.value} name={setting.system_name} onChange={handleChangeInput} type={'number'} /> : ''}
							{setting.type === 'text' ? <TextField size={'small'} placeholder={setting.value} name={setting.system_name} onChange={handleChangeInput} type={'text'} /> : ''}
							{setting.type === 'textarea' ? <TextField size={'small'} placeholder={setting.value} multiline rows={3} name={setting.system_name} onChange={handleChangeInput} type={'textarea'} /> : ''}
							{setting.type === 'file' ? <Upload text={t('upload_video')} type="video" files={file} setFiles={setFile} /> : ''}

							{setting.type === 'array' ? (
								<Autocomplete
									size={'small'}
									freeSolo
									options={['test', 'qwer']}
									renderTags={(value: readonly string[], getTagProps) =>
										value.map((option: string, index: number) => {
											const { key, ...tagProps } = getTagProps({ index });
											return <Chip variant="outlined" label={option} key={key} {...tagProps} />;
										})
									}
									renderInput={params => <TextField {...params} />}
									multiple
									onChange={handleChangeMultiSelectInput(setting.system_name)}
								/>
							) : (
								''
							)}
							{setting.type === 'single_model' ? (
								<TextField size={'small'} select name={setting.system_name} onChange={handleChangeInput}>
									{modelsList.map((data: modelList) => {
										if (!data.list || !Array.isArray(data.list)) {
											return null;
										}
										return data.list.map((item: any) => {
											if (data.system_name === setting.system_name) {
												return (
													<MenuItem key={`maneger ${item.id}`} value={item.title}>
														{item.title}
													</MenuItem>
												);
											}
											return null;
										});
									})}
								</TextField>
							) : null}
							<Typography className={'text-text-secondar y'}>{t(setting.description)}</Typography>
						</div>
					</div>
				))}
				<Button className={'mt-4'} onClick={handleSubmit} variant={'contained'}>
					{t('register')}
				</Button>
			</div>
		</Box>
	);
}
